import React from "react";
import {ReactSession} from "react-client-session";
import {toast} from "react-toastify";
import {Helpers} from "../../config/Helpers";
import queryString from "query-string";
import {encode as base64_encode} from "base-64";
import PasswordStrengthBar from 'react-password-strength-bar';

class ResetPassword extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            urlParam: queryString.parse(window.location.search),
            secureTextNew: true,
            secureTextConfirm: true
        }
    }

    componentDidMount() {
        if(this.state.urlParam.email && this.state.urlParam.token){
            this.setState({
                email: this.state.urlParam.email,
                token: this.state.urlParam.token
            });
        }
    }

    viewPassword = (state) => {
        this.setState({[state]: !this.state[state]});
    };

    handleSubmit = (e) => {
        e.preventDefault();

        let error = false;
        let message = '';
        if (this.state.new.length < 8) {
            message += "Your password needs a minimum of eight characters. ";
            error = true;
        }
        if (this.state.new.search(/[a-z]/) == -1) {
            message += "Your password needs at least one lower case letter. ";
            error = true;
        }
        if (this.state.new.search(/[A-Z]/) == -1) {
            message += "Your password needs at least one upper case letter. ";
            error = true;
        }
        if (this.state.new.search(/[0-9]/) == -1) {
            message += "Your password needs at least one number. ";
            error = true;
        }
        if (this.state.new.search(/[!@#$%^&*]/) == -1) {
            message += "Your password needs at least one symbol. ";
            error = true;
        }
        if (error) {
            toast.error(message);
            return;
        }

        Helpers.resetPassword(this.state.email, this.state.token, this.state.new, this.state.confirm).then(res => {
            if(res.length > 0){
                if(res[0].alert == 'success'){
                    this.setState({
                        email: '',
                        token: '',
                        new: '',
                        confirm: ''
                    });

                    window.location.href = '/login';
                }

                toast[res[0].alert](res[0].message);
            }else{
                toast.error(Helpers.MSG_ERROR);
            }
        })
    };

    render() {
        return (
            <>
                <main className="main pages mb-80">
                    <div className="page-content pt-10">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6 m-auto">
                                    <div className="card">
                                        <div className="card-header">
                                            <h3 className="mb-0">Reset Password</h3>
                                        </div>
                                        <div className="card-body contact-from-area">
                                            <p>Pastikan untuk mengisi data dengan benar sebelum
                                                melakukan submit.</p>
                                            <form className="contact-form-style mt-30 mb-30"
                                                  method="post" onSubmit={(e) => {this.handleSubmit(e)}}>
                                                <div className="input-style mb-20">
                                                    <label>Password Baru</label>
                                                    <div className="row">
                                                        <div className="col-9">
                                                            <input value={this.state.new} onChange={e => this.setState({new: e.target.value})}
                                                                   placeholder="Masukkan Password"
                                                                   type={(this.state.secureTextNew) ? 'password' : 'text'} required/>
                                                        </div>
                                                        <div className="col-3">
                                                            <button type="button"
                                                                    className="btn btn-heading btn-block hover-up"
                                                                    onClick={() => {this.viewPassword('secureTextNew')}} style={{'padding': '20px 30px'}}>
                                                                {
                                                                    this.state.secureTextNew && (
                                                                        <i className="fi-rs-eye"></i>
                                                                    )
                                                                }
                                                                {
                                                                    !this.state.secureTextNew && (
                                                                        <i className="fi-rs-eye-crossed"></i>
                                                                    )
                                                                }
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <small>Use at least 8 character and include number, uppercase letter, lowercase letter and symbol.</small>
                                                    <PasswordStrengthBar password={this.state.new} />
                                                </div>
                                                <div className="input-style mb-20">
                                                    <label>Ulangi Password Baru</label>
                                                    <div className="row">
                                                        <div className="col-9">
                                                            <input value={this.state.confirm} onChange={e => this.setState({confirm: e.target.value})}
                                                                   placeholder="Masukkan Password"
                                                                   type={(this.state.secureTextConfirm) ? 'password' : 'text'} required/>
                                                        </div>
                                                        <div className="col-3">
                                                            <button type="button"
                                                                    className="btn btn-heading btn-block hover-up"
                                                                    onClick={() => {this.viewPassword('secureTextConfirm')}} style={{'padding': '20px 30px'}}>
                                                                {
                                                                    this.state.secureTextConfirm && (
                                                                        <i className="fi-rs-eye"></i>
                                                                    )
                                                                }
                                                                {
                                                                    !this.state.secureTextConfirm && (
                                                                        <i className="fi-rs-eye-crossed"></i>
                                                                    )
                                                                }
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <button className="submit submit-auto-width"
                                                        type="submit">Submit
                                                </button>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </>
        );
    }
}

export default ResetPassword;